import React from 'react';
import { Route, Routes } from 'react-router-dom';

import SettingsSidebar from '../components/settings/SettingsSidebar';
import Widgets from '../components/client-setup/pages/widgets/Widgets';
import { Integration } from '../components/client-setup/pages/account-integration/Integration';
import CreateUserSetting from '../components/setting-users/CreateUserSetting';
import Configuration from '../components/settings/configuration/Configuration';
import CreateCompanyProfile from '../components/client-setup/pages/create-company-profile/CreateCompanyProfile';
import SubscriptionDetail from '../components/subscription/SubscriptionDetail';
import CreateMenu from '../components/client-setup/pages/cretate-menun/CreateMenu';
import CreateProduct from '../components/client-setup/pages/create-product/CreateProduct';
import Faq from '../components/client-setup/pages/faq/Faq';

const SettingsNavigation = () => {
  const settingsNavigation = [
    {
      path: 'widgets',
      element: (
        <SettingsSidebar>
          <Widgets isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'faq',
      element: (
        <SettingsSidebar>
          <Faq isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'integration',
      element: (
        <SettingsSidebar>
          <Integration isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'users/create-user',
      element: (
        <SettingsSidebar>
          <CreateUserSetting />
        </SettingsSidebar>
      )
    },
    {
      path: 'users/update-user/:id',
      element: (
        <SettingsSidebar>
          <CreateUserSetting />
        </SettingsSidebar>
      )
    },
    {
      path: 'configuration',
      element: (
        <SettingsSidebar>
          <Configuration />
        </SettingsSidebar>
      )
    },
    {
      path: 'profile',
      element: (
        <SettingsSidebar>
          <CreateCompanyProfile isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'menu',
      element: (
        <SettingsSidebar>
          <CreateMenu isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'catalouge',
      element: (
        <SettingsSidebar>
          <CreateProduct isSettings={true} />
        </SettingsSidebar>
      )
    },
    {
      path: 'subscription',
      element: (
        <SettingsSidebar>
          <SubscriptionDetail />{' '}
        </SettingsSidebar>
      )
    }
  ];

  return (
    <Routes>
      {settingsNavigation.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default SettingsNavigation;
